"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-nocheck


var _1 = require(".");

exports.popperGenerator = _1.popperGenerator;
exports.detectOverflow = _1.detectOverflow;

var eventListeners_1 = tslib_1.__importDefault(require("./modifiers/eventListeners"));

var popperOffsets_1 = tslib_1.__importDefault(require("./modifiers/popperOffsets"));

var computeStyles_1 = tslib_1.__importDefault(require("./modifiers/computeStyles"));

var applyStyles_1 = tslib_1.__importDefault(require("./modifiers/applyStyles"));

var offset_1 = tslib_1.__importDefault(require("./modifiers/offset"));

var flip_1 = tslib_1.__importDefault(require("./modifiers/flip"));

var preventOverflow_1 = tslib_1.__importDefault(require("./modifiers/preventOverflow"));

var arrow_1 = tslib_1.__importDefault(require("./modifiers/arrow"));

var hide_1 = tslib_1.__importDefault(require("./modifiers/hide"));

var defaultModifiers = [eventListeners_1["default"], popperOffsets_1["default"], computeStyles_1["default"], applyStyles_1["default"], offset_1["default"], flip_1["default"], preventOverflow_1["default"], arrow_1["default"], hide_1["default"]];
exports.defaultModifiers = defaultModifiers;

var createPopper = _1.popperGenerator({
  defaultModifiers: defaultModifiers
});

exports.createPopper = createPopper;